import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { TaskScaiObject } from 'src/app/models/tasks/tasks-details/tasks-details-scai/task-scai.model';

@Injectable({
    providedIn: 'root'
})
export class TaskScaiConverter implements Converter<TaskScaiObject> {

    public convert(input: any): TaskScaiObject {
        try {
            if (isNullOrUndefined(input)) {
                return TaskScaiObject.create();
            }
            return new TaskScaiObject(StringUtils.default(input.order.scai.request), StringUtils.default(input.order.scai.response));
        } catch (error) {
            console.error(error);
            return TaskScaiObject.create();
        }
    }
}
